import React from "react";
import path from "path";
import Accordion from "mrf/view/Accordion";
import T from 'mrf/utils/T';
import { StyledSideMenu, StyledSideMenuLink } from "styles/components/SideMenu.styles";
import IFAuth from 'mrf/view/IFAuth.js';
import Flex from "mrf/layout/Flex";

const SideMenu = ({ match, list, width=64 }) => {
    return (
        <Flex width={width}>
            <StyledSideMenu width={width}>
                {list.filter(item => !item.routeOnly).map((item, i) => (
                    <IFAuth key={i} roleCodes={item?.roleCodes}>
                        <div>
                            {item.path ? (
                                <StyledSideMenuLink
                                    to={path.join(match.url, item.path)}
                                    activeClassName="active"
                                ><p><T>{ item.title }</T></p></StyledSideMenuLink>
                            ) : (
                                <Accordion
                                    match={match}
                                    title={item.title}
                                    subItems={item.subMenu}
                                />
                            )}
                        </div>
                    </IFAuth>
                ))}
            </StyledSideMenu>
        </Flex>
    );
};

export default SideMenu;
